import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Reveal from "@/components/Reveal";
import ContextLine from "@/components/ContextLine";

export default function FinalCTA() {
  const navigate = useNavigate();
  return (
    <section data-testid="final-cta-section" className="bg-navy text-white" style={{ backgroundColor: "var(--navy)" }}>
      <div className="mx-auto max-w-[1100px] px-6 sm:px-10 py-28 sm:py-36">
        <Reveal className="relative">
          <div className="relative px-8 sm:px-16 py-16 sm:py-24 text-center">
            {/* The Siaq line ends as a gate around the button (draws once, then still) */}
            <ContextLine
              d="M120,300 L120,120 C120,50 360,20 600,20 C840,20 1080,50 1080,120 L1080,300"
              viewBox="0 0 1200 320"
              className="absolute inset-0 w-full h-full pointer-events-none"
              strokeWidth={2}
              duration={2.2}
            />
            <div className="relative">
              <span className="eyebrow mb-6" style={{ justifyContent: "center" }}>لسياقك نبتكر</span>
              <h2 className="font-display leading-tight" style={{ fontSize: "clamp(1.7rem, 3.3vw, 2.8rem)" }}>
                اكتشف سياق منظمتك
              </h2>
              <p className="mt-5 text-white/75 text-lg max-w-xl mx-auto leading-relaxed">
                خطوة واحدة تفصلك عن فهمٍ أعمق لمنظمتك وحلٍّ مصمّم على سياقها.
              </p>
              <button
                onClick={() => navigate("/discover-context")}
                data-testid="final-cta-button"
                className="group mt-9 inline-flex items-center gap-2 bg-coral text-white px-8 py-4 text-base font-semibold hover:bg-[#d85a5e] transition-colors"
                style={{ backgroundColor: "var(--coral)" }}
              >
                ابدأ تشخيص منظمتك
                <ArrowLeft size={18} className="transition-transform group-hover:-translate-x-1" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
